import { __awaiter, __generator, __values } from 'tslib';
import { stargate } from './stargateService.esm.js';

function getFeatureFlags(_a) {
    var flagNames = _a.flagNames, context = _a.context, projectName = _a.projectName, appName = _a.appName;
    return __awaiter(this, void 0, void 0, function () {
        var response, data, responseData, _b, _c, flag;
        var e_2, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, stargate.featureFlags.getFeatureFlagsRaw({
                            featureFlagsRequestDto: {
                                appName: appName,
                                context: context,
                                flagNames: flagNames,
                                projectName: projectName,
                            },
                        })];
                case 1:
                    response = _e.sent();
                    data = {};
                    return [4 /*yield*/, response.value()];
                case 2:
                    responseData = _e.sent();
                    try {
                        for (_b = __values(responseData.featureFlags), _c = _b.next(); !_c.done; _c = _b.next()) {
                            flag = _c.value;
                            data[flag.name] = flag.enabled;
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    return [2 /*return*/, { data: data, status: response.raw.status, statusText: response.raw.statusText }];
                case 3:
                    _e.sent();
                    // TODO: return default values? log the error?
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
}

export { getFeatureFlags };
//# sourceMappingURL=featureFlags.esm.js.map
